window.masks = function () {
    document.querySelectorAll('.mask-cpf').forEach(function (el) {
        IMask(el, {
            mask: '000.000.000-00',
            lazy: true,
        })
    });

    document.querySelectorAll('.mask-zipcode').forEach(function (el) {
        IMask(el, {
            mask: '00000-000',
            lazy: true,
        })
    });

    document.querySelectorAll('.mask-phone').forEach(function (el) {
        IMask(el, {
            mask: [
                {
                  mask: '(00) 0000-0000[0]',
                  lazy: true
                },
                {
                  mask: '(00) 00000-0000',
                  lazy: true
                },
            ],
            dispatch: function (appended, dynamicMasked) {
                var number = (dynamicMasked.value + appended).replace(/\D/g,'');
          
                return dynamicMasked.compiledMasks.find(function (m) {
                    return m.mask.length == 15 && number.length == 11 || m.mask.length == 17 && number.length < 11;
                });
            },
            lazy: true,
        })
    })

    document.querySelectorAll('.mask-cnpj').forEach(function (el) {
        IMask(el, {
            mask: '00.000.000/0000-00',
            lazy: true,
        })
    })

    document.querySelectorAll('.mask-date').forEach(function (el) {
        IMask(el, {
            mask: '00/00/0000',
            lazy: true,
        })
    })

    document.querySelectorAll('.mask-date-cupom').forEach(function (el) {
        IMask(el, {
            mask: '00/00/0000',
            lazy: true,
        })
    })

    document.querySelectorAll('.mask-money').forEach(function (el) {
        const args = {
            afterFormat(e) { },
            allowNegative: false,
            beforeFormat(e) { },
            negativeSignAfter: false,
            prefix: '',
            suffix: '',
            fixed: true,
            fractionDigits: 2,
            decimalSeparator: ',',
            thousandsSeparator: '.',
            cursor: 'end'
        };
        const input = SimpleMaskMoney.setMask(el, args);
        input.addEventListener('focus', function() {
        })
    })

    document.querySelectorAll('.only-number').forEach(function (el) {
        IMask(el, {
            mask: Number
        })
    })
}


